import React from 'react'
import styled from '@emotion/styled'
import { ActiveLink } from 'raviger'
import { colors } from 'Constants'
import { isUrlExternal } from 'Helpers'

const A = ({ href, children, ...props }) => {
  return !href || isUrlExternal(href) ? (
    <a target="_blank" rel="noopener noreferrer" href={href} {...props}>
      {children}
    </a>
  ) : (
    <ActiveLink
      activeClass="active-link"
      exactActiveClass="exact-active-link"
      href={href}
      children={children}
      {...props}
    />
  )
}

export default styled(A)`
  position: relative;
  color: ${({ reset, color }) => (reset ? 'inherit' : color || colors.accent)};
  text-decoration: none;
  cursor: pointer;

  ::after {
    ${props => props.underline && "content: '';"}
    background-color: ${props => props.color || colors.accent};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    width: 0;
    transition: 0.2s width;
  }

  :hover::after {
    width: 100%;
  }
`
